import React from 'react';

export default class DetailTitle extends React.Component {
  render() {
    let { title, boxStyle = {} } = this.props;

    return (
      <div
        style={{
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: '#dddddd',
          marginTop: '15px',
          marginBottom: '15px',
          ...boxStyle
        }}
      >
        <span
          style={{
            margin: '-1px',
            display: 'inline-block',
            verticalAlign: 'middle',
            fontSize: '12px',
            position: 'relative',
            lineHeight: 1,
            padding: '0 15px 10px',
            textAlign: 'center',
            listStyle: 'none',
            color: '#0070C2',
            borderBottom: '2px solid #0070C2'
          }}
        >
          {title}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailTitle/index.js